import(/* webpackMode: "eager" */ "/app/app/(new-pages)/(companies)/[lang]/companies/error.tsx");
